import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../rootReducer";

interface MenuLayoutState {
  menuLayout: {
    isOpen: boolean;
  };
}

const initialState: MenuLayoutState = {
  menuLayout: {
    isOpen: true,
  },
};

export const menuLayoutSlice = createSlice({
  name: "menuLayout",
  initialState,
  reducers: {
    setMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.menuLayout.isOpen = action.payload;
    },
  },
});

export const { setMenuOpen } = menuLayoutSlice.actions;

export const selectMenuIsOpen = (state: RootState) => state.trackingApp.menuLayout.menuLayout.isOpen;

export default menuLayoutSlice.reducer;
